import { MediaResourceModel } from '@/modules/media/models/media-resource.model'
import { BasicUserResourceModel } from '@/modules/user/models/user-resource.model'
import { Data } from '@/modules/shared/models/data'

export enum TransactionStatus {
  WAITING_PAYMENT = 'waiting_payment',
  PENDING = 'pending',
  PAID = 'paid',
  UNPAID = 'unpaid',
}

export enum TransactionGateWay {
  ONLINE = 'online',
  WALLET = 'wallet',
  CARD = 'card',
}

export interface TransactionResourceModel {
  id: number,
  description: string | null,
  status: TransactionStatus,
  gateway: TransactionGateWay,
  online_gateway_title: string | null,
  amount: number,
  ref_id: string | null,
  receipt_id: number | null,
  error: string | null,
  card_number: string | null,
  created_at: string | null,
  transactional_type: string | null,
  transactional_id: number | null,
  from_wallet: number | null,
  payable_online: number | null,
  paid_at: string | null,
  attachment: MediaResourceModel[] | null,
  user: BasicUserResourceModel,
  payload: string,
}

export interface TransactionResourceWithModel {
  statuses: { [key in TransactionStatus]: string },
  gateways: { [key in TransactionGateWay]: string },
  transactional_types: Record<string, string>,
  online_gateways?: Record<string, string>,
}

export type TransactionResourceType = Data<TransactionResourceModel> & TransactionResourceWithModel